export default __webpack_public_path__ + "static/media/bp.6401c65d.png";